module.exports = __webpack_public_path__ + "img/integrator-icon.f9d10ef5.svg";